
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M31.446 5.222H16.554v11.332H5.222v14.892h11.332v11.332h14.892V31.446h11.332V16.554H31.446z"}}),_c('path',{staticClass:"i-rod",attrs:{"stroke":"#234652","d":"M21.595 13.682a2.5 2.5 0 0 1 2.497-2.612h.11a2.5 2.5 0 0 1 2.497 2.612l-1.4 31.332a1.153 1.153 0 0 1-2.304 0zm5.574-7.956a3.137 3.137 0 1 1-6.274 0 3.137 3.137 0 0 1 6.274 0Z"}}),_c('path',{staticClass:"i-snake",attrs:{"stroke":"#234652","d":"M28.118 21.025h3.933c2.6.194 3.012 3.094.533 3.749L16.8 28.942c-2.685.709-1.912 3.897.91 3.753h2.959m-.465-11.192h-4.177c-3.421.175-4.36-3.687-1.114-4.553l.013-.003c.214-.054 13.17-3.333 16.182-4.121 3.038-.794 3.438-3.101 1.28-4.765M27.473 32.64h2.5c1.868.139 2.163 2.22.383 2.691l-11.33 2.992c-1.928.51-1.373 2.798.653 2.694h1.219"}})])
          )
        }
      }
    